var React = require('react');

var robot = require('../../images/error-robot.png');

var NotFound = React.createClass({
    render: function () {
        return (
            <div className="standalone-page-wrapper">
                <div className="error-top-block">
                  <div className="error-top-block-image"> <img src={robot} alt="Ooops!" /> </div>
                </div>

                <div className="error-bottom-block">
                  <div className="col-md-6 col-md-offset-3 error-description">
                    <div className="error-code">404 Error</div>
                    <div className="error-meaning">Page not Found</div>
                    <div className="todo">
                      <h4>What to do?</h4>
                      Sorry, but the page you are looking for has not been found on our server. Try checking URL for errors, then hit the refresh button on your browser.
                    </div>
                    <div className="copyrights"> &copy; Infinite Networks Pty Ltd 2014</div>
                  </div>
                </div>
            </div>
        );
    }
})
module.exports = NotFound;



// WEBPACK FOOTER //
// ./app/components/Layout/NotFound.js